import React, { useRef } from 'react';

const CalculateInstallment = (price, manufactured_year) => {
  const currentYear = new Date().getFullYear();
  const tenure = Math.min(15 - (currentYear - manufactured_year), 9);
  if(tenure < 5) {
    return (" ");
  } else {
    const installment = 0.075 * price * (1 + 0.035 * tenure) / tenure;
    return (`RM ${Math.ceil(installment).toLocaleString('en-US')} / month (${tenure} years)`)
  }
}


const SmallImageGallery = ({ id, openGallery, data, images }) => {
  const startY = useRef(0);

  const handleTouchStart = (e) => {
    // Record where the vertical scroll started
    startY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = (e) => {
    // Check if the user moved vertically (scrolling the page)
    const moveY = Math.abs(e.changedTouches[0].clientY - startY.current);
    
    // If they moved vertically more than 30px, they are scrolling, not interacting.
    if (moveY > 30) return;
    openGallery(0);
  };
  return (
    <div className="gallery-grid-mobile" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      <img src={ `/images/${id}/advertisement/advertisement_000.jpg` } />
      <button className="nav-btn next-btn" style={{ color: '#FFAE42'}}>
        ›
      </button>
    </div>
  )
}

const ImageGallery = ({ id ,openGallery, data, images }) => {
  const { price, manufactured_year } = data;
  return (
    <div className="gallery-grid">
      <div className="main-photo"
        onClick={() => openGallery(0)}>
        <img src={ `/images/${id}/advertisement/advertisement_000.jpg` } />
      </div>
      <div className="side-photo"
        onClick={() => openGallery(1)}>
        <img src={ `/images/${id}/advertisement/advertisement_001.jpg` } />
      </div>
      <div className="side-photo"
        onClick={() => openGallery(2)}>
        <img src={ `/images/${id}/advertisement/advertisement_002.jpg` } />
      </div>
      <div className="side-photo"
        onClick={() => openGallery(3)}>
        <img src={ `/images/${id}/advertisement/advertisement_003.jpg` } />
      </div>
      <div className="side-photo more-photos"
        onClick={() => openGallery(4)}>
        <img src={ `/images/${id}/advertisement/advertisement_004.jpg` } />
      {
        (images.length-5 > 0) &&
        <div className="overlay">
          +{images.length-5} Photos
        </div>
      }
      </div>
      <div className="gallery-price-div">
        <h3 className="gallery-price-text">RM {price.toLocaleString('en-US')}</h3>
        <p className="gallery-installment-text">{CalculateInstallment(price, manufactured_year)}</p>
      </div>
    </div>
  )
}

export default function ReportSummary({ data, id, openGallery, images }) {
  const { manufactured_year, registered_date, manufacturer, model, cc, fuel_type, transmission, price, advertisement_img, mileage } = data;
  return(
    <div className="report-section">
      <h2>Vehicle Information</h2>
      <ImageGallery id={id} openGallery={openGallery} data={data} images={images}/>
      <SmallImageGallery id={id} openGallery={openGallery} data={data} images={images}/>
      <div className="summary-grid">
        <div className="card">
          <h3>Model</h3>
          <p>{manufacturer} {model}</p>
        </div>
        <div className="card">
          <h3>Year</h3>
          <p>{manufactured_year}</p>
        </div>
        <div className="card">
          <h3>Mileage</h3>
          <p>{mileage.toLocaleString('en-US')} km</p>
        </div>
        <div className="card">
          <h3>Fuel</h3>
          <p>{fuel_type}</p>
        </div>
        <div className="card">
          <h3>Transmission</h3>
          <p>{transmission}</p>
        </div>
      </div>
      <div className="summary-grid-mobile">
        <div className="price-tag-mobile">
          <h3>RM {price.toLocaleString('en-US')}</h3>
          <p>{CalculateInstallment(price, manufactured_year)}</p>
        </div>
        <div style={{display:"flex"}}>
          <h3>Model</h3>
          <div style={{flexGrow:1}} />
          <h3>{manufacturer} {model}</h3>
        </div>
        <div style={{display:"flex"}}>
          <h3>Year</h3>
          <div style={{flexGrow:1}} />
          <h3>{manufactured_year}</h3>
        </div>
        <div style={{display:"flex"}}>
          <h3>Mileage</h3>
          <div style={{flexGrow:1}} />
          <h3>{mileage.toLocaleString('en-US')} km</h3>
        </div>
        <div style={{display:"flex"}}>
          <h3>Fuel</h3>
          <div style={{flexGrow:1}} />
          <h3>{fuel_type}</h3>
        </div>
        <div style={{display:"flex"}}>
          <h3>Transmission</h3>
          <div style={{flexGrow:1}} />
          <h3>{transmission}</h3>
        </div>
      </div>
    </div>
  )
}

